import { DatePicker } from '@lmt/unicorn-shared/app/components/common/ui-kit/inputs/date-time/DatePicker';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';
import styles from './GDTMessagesFilter.module.scss';
import { Field } from '../../../common/Field';
import { Button, ButtonColor } from '../../../common/ui-kit/buttons/Button';

type Props = {
  from: Date | null;
  to: Date | null;
  onFromChanged: (date: Date | null) => void;
  onToChanged: (date: Date | null) => void;
  onReset: () => void;
  searchKey: number;
};
export const GDTMessagesFilter: React.FC<Props> = React.memo(
  function GDTMessagesFilter(props) {
    const i18n = useScopedTranslation('gdt.messages.filter');
    return (
      <div data-test-id="messages-filter" className={styles.container}>
        <div className={styles.header}>
          {(i18n.t('title') as string).toUpperCase()}
        </div>
        <Field title={i18n.t('filter_from')}>
          <DatePicker
            key={'from' + props.searchKey}
            value={props.from}
            onDateChanged={props.onFromChanged}
            withTime={true}
            displaySeconds={true}
            isFormInput={false}
          />
        </Field>
        <Field title={i18n.t('filter_to')}>
          <DatePicker
            key={'to' + props.searchKey}
            value={props.to}
            withTime={true}
            displaySeconds={true}
            onDateChanged={props.onToChanged}
            isFormInput={false}
          />
        </Field>
        <div>
          <div className={styles.buttonContainer}>
            <Button
              color={ButtonColor.Primary}
              title={i18n.t('refresh_button')}
              onClick={props.onReset}
            />
          </div>
        </div>
      </div>
    );
  },
);
